/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayoutDistribution } from './PayoutDistribution';
import {
    PayoutDistributionFromJSON,
    PayoutDistributionFromJSONTyped,
    PayoutDistributionToJSON,
    PayoutDistributionToJSONTyped,
} from './PayoutDistribution';
import type { PayoutTier } from './PayoutTier';
import {
    PayoutTierFromJSON,
    PayoutTierFromJSONTyped,
    PayoutTierToJSON,
    PayoutTierToJSONTyped,
} from './PayoutTier';

/**
 * 
 * @export
 * @interface CreatePayoutTableBody
 */
export interface CreatePayoutTableBody {
    /**
     * 
     * @type {string}
     * @memberof CreatePayoutTableBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePayoutTableBody
     */
    description?: string;
    /**
     * Optional - for bracket tournaments only
     * @type {number}
     * @memberof CreatePayoutTableBody
     */
    minTeams?: number;
    /**
     * Optional - for bracket tournaments only
     * @type {number}
     * @memberof CreatePayoutTableBody
     */
    maxTeams?: number;
    /**
     * Flat distribution for static tables (at least one of distribution or tiers required)
     * @type {Array<PayoutDistribution>}
     * @memberof CreatePayoutTableBody
     */
    distribution?: Array<PayoutDistribution>;
    /**
     * Dynamic tier-based distribution ordered ascending by minParticipants. When present, overrides distribution.
     * @type {Array<PayoutTier>}
     * @memberof CreatePayoutTableBody
     */
    tiers?: Array<PayoutTier>;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePayoutTableBody
     */
    isDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePayoutTableBody
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the CreatePayoutTableBody interface.
 */
export function instanceOfCreatePayoutTableBody(value: object): value is CreatePayoutTableBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreatePayoutTableBodyFromJSON(json: any): CreatePayoutTableBody {
    return CreatePayoutTableBodyFromJSONTyped(json, false);
}

export function CreatePayoutTableBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePayoutTableBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'minTeams': json['minTeams'] == null ? undefined : json['minTeams'],
        'maxTeams': json['maxTeams'] == null ? undefined : json['maxTeams'],
        'distribution': json['distribution'] == null ? undefined : ((json['distribution'] as Array<any>).map(PayoutDistributionFromJSON)),
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(PayoutTierFromJSON)),
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function CreatePayoutTableBodyToJSON(json: any): CreatePayoutTableBody {
    return CreatePayoutTableBodyToJSONTyped(json, false);
}

export function CreatePayoutTableBodyToJSONTyped(value?: CreatePayoutTableBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'minTeams': value['minTeams'],
        'maxTeams': value['maxTeams'],
        'distribution': value['distribution'] == null ? undefined : ((value['distribution'] as Array<any>).map(PayoutDistributionToJSON)),
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(PayoutTierToJSON)),
        'isDefault': value['isDefault'],
        'isActive': value['isActive'],
    };
}

